export const FILTER_TYPES = {
    LIST: 'LIST',
    TEXT: 'TEXT',
    DATE_RANGE: 'DATE_RANGE',
    DATE_TIME_RANGE: 'DATE_TIME_RANGE',
    NUMBER_RANGE: 'NUMBER_RANGE',
    AMOUNT: 'AMOUNT',
    BOOLEAN: 'BOOLEAN',
} as const;